// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "li a[data-v-1c69867e]{cursor:pointer;text-decoration:none;color:inherit}", ""]);
// Exports
module.exports = exports;
